import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "32",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M21.28 24.854a2.526 2.526 0 1 1 3.573-3.573l17.864 17.864a2.526 2.526 0 0 1-3.573 3.572z" }),
      _createElementVNode("path", { d: "M39.143 21.281a2.527 2.527 0 0 1 3.573 3.573L24.852 42.718a2.526 2.526 0 1 1-3.573-3.573z" })
    ], -1)
  ])))
}
export default { render: render }